import { Typography } from "@mui/material";
import { Box, Switch } from "@procore/core-react";
import { useTranslation } from "react-i18next";

interface ToggleWithTextProps {
    checked: boolean;
    onChange: () => void;
    label: string;
    disabled?: boolean;
}

export const ToggleWithText = ({ checked, onChange, label, disabled }: ToggleWithTextProps) => {
    const { t } = useTranslation();
    return (
        <Box
            display="flex"
            alignItems="center"
            gap="0.5rem"
            style={disabled ? { opacity: 0.5, pointerEvents: "none" } : undefined}
        >
            <Switch checked={checked} onChange={onChange} id={`toggle-${label}`} style={{ flexShrink: 0 }} />
            <Typography
                component="label"
                htmlFor={`toggle-${label}`}
                sx={{ color: "text.primary", cursor: disabled ? "default" : "pointer" }}
            >
                {t(label)}
            </Typography>
        </Box>
    );
};
